import React from "react";  

import Header from 'components/Landpage/Header'
import Footer from 'components/Landpage/Footer' 

import { 
    Content
} from "./styled"; 
import { ThemedComponent } from "ui/theme";

export default function ContainerLandpage({ children }){ 
 
    return ( 
        <ThemedComponent>
            <Content>
                <Header />
                    { children }
                {/* <Footer />  */}
            </Content>
        </ThemedComponent>
    );
}